import type { ReactNode } from 'react';

import { MediaButtons, type MediaButtonsProps, MediaExtraButtons } from './media-buttons';
import { MediaSectionHeader } from './media-section-header';

export type MediaDataLayoutProps = {
  children?: ReactNode;
  page: string;
  isEditable?: boolean;
} & MediaButtonsProps;

export const MediaDataLayout = ({
  children,
  page,
  isEditable = true,
  ...props
}: MediaDataLayoutProps) => {
  const id = props.type === 'estate' ? props.estateId : props.projectId;

  return (
    <div className="flex flex-col gap-4">
      <MediaSectionHeader type={props.type} id={id} page={page}>
        {isEditable ? <MediaButtons {...props} /> : null}
      </MediaSectionHeader>
      {isEditable ? <MediaExtraButtons {...props} /> : null}
      {children}
    </div>
  );
};
